import { call, fork, put, select, takeLatest } from "redux-saga/effects";
import { preloadImages } from "../../../common/preload/preloadImages";
import { ChangeCurrentAttachmentId, setCurrentAttachmentId } from "../actions";
import { ActionTypes } from "../const/ActionTypes";
import { ImagesEntities } from "../reducers/entities";
import { getAttachmentIds, getImagesEntities } from "../selectors";

function getSourcesImage(currentId: number, ids: number[], images: ImagesEntities) {
    const len = ids.length;
    const index = ids.indexOf(currentId);
    const previous = ids[index === 0 ? len - 1 : index - 1];
    const next = ids[index === len - 1 ? 0 : index + 1];
    const result = [];

    if (currentId !== next) {
        result.push(images[next].source);

        if (next !== previous) {
            result.push(images[previous].source);
        }
    }

    return result;
}

function* setCurrentImage({ value }: ChangeCurrentAttachmentId) {
    const ids: number[] = yield select(getAttachmentIds);
    const entities: ReturnType<typeof getImagesEntities> = yield select(getImagesEntities);
    const sources: ReturnType<typeof getSourcesImage> = yield call(getSourcesImage, value, ids, entities);

    yield call(preloadImages, sources);
    yield put(setCurrentAttachmentId(value));
}

export function* changeCurrentImage() {
    yield takeLatest(ActionTypes.CHANGE_CURRENT_ATTACHMENT_ID, setCurrentImage);
}

export function* watchChangeCurrentImage() {
    yield fork(changeCurrentImage);
}
